import { FunctionComponent, HTMLAttributes, PropsWithChildren } from "react";

import styles from "./SectionTitle.module.css";
import classNames from "classnames";

type TProps = {
  onClick?: () => void;
};

const SectionTitle: FunctionComponent<PropsWithChildren<TProps>> = (props) => {
  let clickProps: HTMLAttributes<HTMLHeadingElement> = {
    className: styles.title,
  };

  if (props.onClick) {
    clickProps = {
      onClick: props.onClick,
      onKeyPress: props.onClick,
      tabIndex: 0,
      role: "button",
      className: classNames(styles.title, {
        [styles.clickable]: Boolean(props.onClick),
      }),
    };
  }

  return <h4 {...clickProps}>{props.children}</h4>;
};

export default SectionTitle;
